








import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { IsValidExternalPath } from '../../../core';

@Component({
  name: 'NavBarLink',
})
export default class NavBarLink extends BaseComponent {
  @Prop({ required: true }) private to!: string;

  // for external values
  // private resolvePath(routePath: string) {
  //   if (IsValidExternalPath(routePath)) {
  //     return routePath;
  //   }
  // }
}
